<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="epigraph_1"></a><p class="ep"><em>I see a red door and I want it painted black,<br/> No colors anymore I want them to turn black . . .</em></p><p class="eps">“Paint It Black,” The Rolling Stones</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PaintItBlack_epig_1.vue?721028c1